module.exports = __webpack_public_path__ + "static/media/all_categories2.f6dc1177.png";